import type { ObjectClass } from '@/type';

export const filterUnknownClass = (objectClass: ObjectClass) =>
  objectClass.classType !== 'Unknown';
